import React from 'react';
import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import { getCurrentLanguage } from '@utils/i18n';
import esMessages from '../locales/kendo/es.json';
import frMessages from '../locales/kendo/fr.json';
// Load UI component messages once when module is imported
loadMessages(esMessages, 'es');
loadMessages(frMessages, 'fr');
/**
 * KendoLocalizationProvider wraps components with LocalizationProvider
 * to provide Kendo React UI components with localized messages for UI elements (buttons, labels, etc).
 * For date/time and number formatting, use KendoIntlProvider separately.
 *
 * @example
 * <KendoLocalizationProvider>
 *   <MyComponent />
 * </KendoLocalizationProvider>
 */
export function KendoLocalizationProvider({ children, language = getCurrentLanguage() }) {
    return React.createElement(LocalizationProvider, { language: language }, children);
}
